(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/redbeemedia/assets/javascripts/video-player-progress-bar.js') >= 0) return;  svs.modules.push('/components/components/redbeemedia/assets/javascripts/video-player-progress-bar.js');

'use strict';

var ProgressBar = function ProgressBar(_ref) {
  var currentSeek = _ref.currentSeek,
    currentSeekPositionRef = _ref.currentSeekPositionRef,
    currentTime = _ref.currentTime,
    currentTimePosition = _ref.currentTimePosition,
    duration = _ref.duration,
    isVOD = _ref.isVOD,
    progressBarRef = _ref.progressBarRef,
    seekTimer = _ref.seekTimer,
    seekTimerRef = _ref.seekTimerRef,
    seekTimerPosition = _ref.seekTimerPosition,
    seekToPosition = _ref.seekToPosition,
    setSeekTime = _ref.setSeekTime;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "vjs-progress-control vjs-control"
  }, React.createElement("div", {
    className: "vjs-progress-holder vjs-slider vjs-slider-horizontal",
    onClick: function onClick(evt) {
      var x = evt.nativeEvent.offsetX;
      var percentagePosition = x / progressBarRef.current.clientWidth;
      seekToPosition(percentagePosition, x);
    },
    onMouseMove: function onMouseMove(evt) {
      var x = evt.nativeEvent.offsetX;
      var percentagePosition = x / progressBarRef.current.clientWidth;
      setSeekTime(percentagePosition, x);
    },
    ref: progressBarRef,
    role: "slider",
    tabIndex: "0"
  }, React.createElement("div", {
    className: "vjs-load-progress",
    style: {
      width: '100%'
    }
  }, React.createElement("div", {
    style: {
      left: '100%',
      width: '0%'
    }
  })), React.createElement("div", {
    className: "vjs-mouse-display"
  }, React.createElement("div", {
    className: "vjs-time-tooltip",
    ref: seekTimerRef,
    style: {
      left: seekTimerPosition
    }
  }, seekTimer)), React.createElement("div", {
    className: "vjs-play-progress vjs-slider-bar",
    style: {
      width: "".concat(currentSeek, "%")
    }
  }, isVOD() && React.createElement("div", {
    className: "vjs-time-tooltip",
    ref: currentSeekPositionRef,
    style: {
      left: currentTimePosition
    }
  }, currentTime)))), isVOD() && React.createElement("div", {
    className: "vjs-duration-info"
  }, "".concat(currentTime, " / ").concat(duration)));
};
svs.components.redbee_video_player.ProgressBar = ProgressBar;

 })(window);